/**
 * Hook for toggling chat enabled/disabled status
 */

import type { ChatToggleData } from '@choco-admin/types';
import { useCallback } from 'react';

import { useUpdateChatEnabled } from './useUpdateChatEnabled';

export interface UseChatToggleResponse {
  toggleChat: (data: ChatToggleData) => Promise<void>;
  isToggling: boolean;
  error: Error | null;
}

export const useChatToggle = (): UseChatToggleResponse => {
  const { updateChatEnabled, isUpdating, error } = useUpdateChatEnabled();

  const toggleChat = useCallback(
    async (data: ChatToggleData) => {
      await updateChatEnabled({
        id: data.id,
        enabled: data.enabled,
      });
    },
    [updateChatEnabled]
  );

  return {
    toggleChat,
    isToggling: isUpdating,
    error,
  };
};
